import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--tabs"
export default class extends Controller {
  static targets = ["content", "tab"];

  initialize() {
    this.showPanelByIndex(0);
  }

  selectTab(event) {
    event.preventDefault();
    const dataSet = event.currentTarget.dataset;

    this.activatePanel(dataSet);

    this.activateTab(event.currentTarget);
  }

  reset() {
    this.showPanelByIndex(0);
  }

  activatePanel(dataSet) {
    this.contentTargets.forEach((content) => {
      content.hidden = true;
      content.classList.remove("active");
    });

    const panel = document.getElementById(dataSet.forTab);
    panel.hidden = false;
    panel.classList.add("active");
  }

  activateTab(tab) {
    this.tabTargets.forEach((tabElement) => {
      tabElement.classList.remove("active");
    });
    tab.classList.add("active");
  }

  showPanelByIndex(index) {
    const tab = this.tabTargets[index];
    this.activatePanel(tab.dataset);
    this.activateTab(tab);
  }
}
